export default __webpack_public_path__ + "static/media/declined.7eef0dc2.svg";